// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__goBPd","voopoBtn":"Button_voopoBtn__+MzQJ","voopoBtnLight":"Button_voopoBtnLight__whVZD","voopoBtnWhite":"Button_voopoBtnWhite__MFHut"};